import { request } from '@/common/services/request';

const getPayloadData = (payload) => payload?.data || payload || {};

export async function queryOrganizations(params) {
  const result = await request('/api/admin/organizations', {
    method: 'GET',
    params,
  });
  return {
    data: result.data,
    success: true,
    total: result.meta?.total || 0,
  };
}

export async function createOrganization(payload) {
  const data = getPayloadData(payload);
  return request('/api/admin/organizations', {
    method: 'POST',
    data,
  });
}

export async function updateOrganization(payload) {
  const data = getPayloadData(payload);
  return request('/api/admin/organizations', {
    method: 'PATCH',
    params: {
      organizationId: data.id,
    },
    data: {
      name: data.name,
      slug: data.slug,
    },
  });
}

export async function updateOrganizationStatus(payload) {
  const data = getPayloadData(payload);
  return request('/api/admin/organizations/status', {
    method: 'PATCH',
    params: {
      organizationId: data.id,
    },
    data: {
      status: data.status,
    },
  });
}

export async function queryOrganizationExternalIdentities(params) {
  return request('/api/admin/organizations/external-identities', {
    method: 'GET',
    params,
  });
}

export async function queryExternalTenantCandidates(params) {
  return request('/api/admin/organizations/external-tenant-candidates', {
    method: 'GET',
    params,
  });
}

export async function queryExternalTenantUsers(params) {
  return request('/api/admin/organizations/external-tenant-users', {
    method: 'GET',
    params,
  });
}

export async function approveOrganizationExternalIdentity(payload) {
  const data = getPayloadData(payload);
  return request('/api/admin/organizations/external-identities', {
    method: 'PUT',
    params: {
      organizationId: data.organizationId,
    },
    data: {
      externalProvider: data.externalProvider,
      externalTenantKey: data.externalTenantKey,
      externalUserId: data.externalUserId,
      role: data.role,
    },
  });
}

export async function queryAdminUsers(params) {
  return request('/api/admin/users', {
    method: 'GET',
    params,
  });
}

export async function updateOrganizationOwner(payload) {
  const data = getPayloadData(payload);
  return request('/api/admin/organizations/owner', {
    method: 'PUT',
    params: {
      organizationId: data.organizationId,
    },
    data: {
      phoneNumber: data.phoneNumber,
      role: 'owner',
    },
  });
}
